import { RequestService } from '../../services/RequestService';
import { GET_DOCUMENTS_TYPES } from '../constants';

export const getDocumentsTypes = () => {
  return RequestService.get(GET_DOCUMENTS_TYPES);
};
